var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-switcher"},[_c('div',{staticClass:"header-switcher_ico"},[_c('i',{class:_vm.getStatus.header.minimaze ? 'icon-icon-up' : 'icon-icon-down',on:{"click":_vm.setStatusHeader}})])])}
var staticRenderFns = []

export { render, staticRenderFns }